import { Table } from '@/components/data-table/table'
import { useTable } from '@/hooks/use-table'
import { BillingHistoryTableColumns } from './billing-history-table-columns'
import { getBillingHistoryOrganizationOrganizationIdBillingHistoryGetOptions } from '@/generated/@tanstack/react-query.gen'
import DownloadAll from './download-all'
import { useQuery } from '@tanstack/react-query'
import { useUser } from '../../user-provider'
import { billingHistoryResponseDTO } from '../_data/billing-history-DTO'
import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import { useState } from 'react'
import { ITEM_PER_PAGE } from '../_data/billing-history-definition'
import { isEmpty } from 'lodash'

export default function BillingHistoryTable() {
  const { organizationId } = useUser()
  const [firtInvoice, setFirstInvoice] = useState<string | undefined>(undefined)
  const [lastInvoice, setLastInvoice] = useState<string | undefined>(undefined)
  const [isNextPage, setIsNextPage] = useState(false)
  const [page, setPage] = useState(1)

  const { data, isLoading } = useQuery({
    ...getBillingHistoryOrganizationOrganizationIdBillingHistoryGetOptions({
      path: {
        organization_id: organizationId,
      },
      query: {
        first_invoice: firtInvoice,
        last_invoice: lastInvoice,
        limit: ITEM_PER_PAGE,
      },
    }),
    select: (data) => billingHistoryResponseDTO(data, page),
  })

  const { table } = useTable({
    data: data?.items ?? [],
    columns: BillingHistoryTableColumns,
    pageCount: 0, // 0 stands for unknown
  })

  return (
    <div>
      <div className="flex items-center justify-end flex-wrap">
        <DownloadAll show={!isEmpty(data?.items)} />
      </div>

      <Table
        disablePagination
        isLoading={isLoading}
        table={table}
        emptyMessage="No billing history found."
      />

      {!isEmpty(data?.items) && (
        <div className="flex justify-end mt-8">
          <div className="h-9 border w-24 rounded-lg flex flex-row border-[#D5D5D5] bg-white">
            <Button
              disabled={page === 1 && !isNextPage}
              onClick={() => {
                setIsNextPage(false)
                setPage(page - 1)
                setFirstInvoice(data?.items[0].id)
                setLastInvoice(undefined)
              }}
              aria-label="Go to previous page"
              variant="outline"
              className="size-8 p-0 w-full rounded-none bg-transparent !rounded-l-lg"
            >
              <svg
                width="8"
                height="12"
                viewBox="0 0 8 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.41 10.4064L2.83 5.99999L7.41 1.59359L6 0.23999L0 5.99999L6 11.76L7.41 10.4064Z"
                  fill="#202224"
                />
              </svg>
            </Button>
            <Separator className="w-[1px] bg-[#D5D5D5] h-full" />
            <Button
              disabled={!data?.hasMore}
              onClick={() => {
                setIsNextPage(true)
                setPage(page + 1)
                setFirstInvoice(undefined)
                setLastInvoice(data?.items[data?.items.length - 1].id)
              }}
              aria-label="Go to next page"
              variant="outline"
              className="size-8 p-0 w-full rounded-none bg-transparent !rounded-r-lg"
            >
              <svg
                width="8"
                height="12"
                viewBox="0 0 8 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.59 10.4064L5.17 5.99999L0.59 1.59359L2 0.23999L8 5.99999L2 11.76L0.59 10.4064Z"
                  fill="#202224"
                />
              </svg>
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}
